import { render, staticRenderFns } from "./TotalWrapper.vue?vue&type=template&id=243a4714"
import script from "./TotalWrapper.vue?vue&type=script&lang=js"
export * from "./TotalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports